import { SideNavItem } from 'app/models/SideNavItem';
import { AppOverviewSectionComponent } from './sections/app-overview-section/app-overview-section.component';
import { AppRiskOverviewSectionComponent } from './sections/app-risk-overview-section/app-risk-overview-section.component';
import { AppSpoofingSectionComponent } from './sections/app-spoofing-section/app-spoofing-section.component';
import { AppDetailsSectionComponent } from './sections/app-details-section/app-details-section.component';
import { AppDeveloperOverviewSectionComponent } from './sections/app-developer-overview-section/app-developer-overview-section.component';
import { AppCountryRankingsSectionComponent } from './sections/app-country-rankings-section/app-country-rankings-section.component';
import { AppChannelsSectionComponent } from './sections/app-channels-section/app-channels-section.component';
import { AppPlatformDistributionSectionComponent } from './sections/app-platform-distribution-section/app-platform-distribution-section.component';
import { AppBrandSafetySectionComponent } from './sections/app-brand-safety-section/app-brand-safety-section.component';
import { AppTrafficTrendsSectionComponent } from './sections/app-traffic-trends-section/app-traffic-trends-section.component';
import { AppAuthorizedSellerSectionComponent } from './sections/app-authorized-seller-section/app-authorized-seller-section.component';
import { AppIvtSectionComponent } from './sections/app-ivt-section/app-ivt-section.component';
import { AppAdSpendSectionComponent } from './sections/app-ad-spend-section/app-ad-spend-section.component';
import { AppInventorySectionComponent } from './sections/app-inventory-section/app-inventory-section.component';
import { AppCtvCoppaViolationRiskSectionComponent as AppCtvCoppaViolationRiskSectionComponent } from './sections/ctv-coppa-violation-risk-section/ctv-coppa-violation-risk-section.component';
import { AppMfaSectionComponent } from './sections/app-mfa-section/app-mfa-section.component';

export const ctvDetailsNavItems: Array<SideNavItem> = [
  {
    key: 'overview',
    iconURL: '/assets/images/sidenav-icon-overview.svg',
    label: 'Overview',
    widgetComponent: AppOverviewSectionComponent,
    showInFreemium: true
  },
  {
    key: 'app-risk-overview',
    iconURL: '/assets/images/sidenav-icon-risk-overview.svg',
    label: 'Risk Overview',
    widgetComponent: AppRiskOverviewSectionComponent,
    showInFreemium: true
  },
  {
    key: 'app-spoofing',
    iconURL: '/assets/images/sidenav-icon-app-spoofing.svg',
    label: 'App Spoofing',
    widgetComponent: AppSpoofingSectionComponent,
    showIf: {
      hasData: {
        notEmpty: 'spoofingByAppDistribution/appsByFraudType'
        //includeAppSpoofing TODO
      }
    },
    showInFreemium: true
  },
  {
    key: 'app-details',
    iconURL: '/assets/images/sidenav-icon-app-details.svg',
    label: 'App Details',
    widgetComponent: AppDetailsSectionComponent,
    showInFreemium: true
  },
  {
    key: 'app-developer-overview',
    iconURL: '/assets/images/sidenav-icon-developer-overview.svg',
    label: 'Developer Overview',
    widgetComponent: AppDeveloperOverviewSectionComponent,
    showInFreemium: true
  },
  {
    key: 'app-country-rankings',
    iconURL: '/assets/images/sidenav-icon-rankings.svg',
    label: 'Rankings',
    widgetComponent: AppCountryRankingsSectionComponent,
    showIf: {
      hasData: {
        notNull: 'rankingsByCountry',
        notEmpty: ['rankingsByCountry/reach', 'rankingsByCountry/marketShare']
      }
    }
  },
  {
    key: 'app-coppa-permission-risk',
    iconURL: '/assets/images/icon-24-brand-safety.svg',
    label: 'COPPA Violation Risk',
    widgetComponent: AppCtvCoppaViolationRiskSectionComponent,
    showIf: {
      hasData: {
        notNull: 'coppaPermissions'
      }
    }
  },
  {
    key: 'app-platform-distribution',
    iconURL: '/assets/images/sidenav-icon-channels.svg',
    label: 'Platform Distribution',
    widgetComponent: AppPlatformDistributionSectionComponent,
    showIf: {
      hasData: {
        notEmpty: 'platformDistribution'
      }
    }
  },
  {
    key: 'app-channels',
    iconURL: '/assets/images/sidenav-icon-channels.svg',
    label: 'Channels',
    widgetComponent: AppChannelsSectionComponent,
    showIf: {
      hasData: {
        notEmpty: 'channelDistribution'
      }
    }
  },
  {
    key: 'app-brand-safety',
    iconURL: '/assets/images/sidenav-icon-brand-safety.svg',
    label: 'Brand Safety',
    beta: true,
    widgetComponent: AppBrandSafetySectionComponent,
    showInFreemium: true
  },
  {
    key: 'app-traffic-overlap',
    iconURL: '/assets/images/sidenav-icon-traffic-overlap.svg',
    label: 'Traffic Trends',
    beta: true,
    widgetComponent: AppTrafficTrendsSectionComponent,
    showInFreemium: true
  },
  {
    key: 'app-authorized-seller',
    iconURL: '/assets/images/sidenav-icon-authorized-seller.svg',
    label: 'Authorized Seller (app-ads.txt)',
    beta: true,
    widgetComponent: AppAuthorizedSellerSectionComponent,
    showIf: {
      hasData: {
        notEmpty: 'sellerDistribution/sellers'
      }
    },
    showInFreemium: true
  },
  {
    key: 'app-mfa',
    iconURL: '/assets/images/icon-mfa.svg',
    label: 'Made For Advertising',
    beta: true,
    widgetComponent: AppMfaSectionComponent
  },
  {
    key: 'app-ivt',
    iconURL: '/assets/images/sidenav-icon-invalid-traffic.svg',
    label: 'Invalid Traffic',
    alwaysShow: true,
    widgetComponent: AppIvtSectionComponent,
    showIf: {
      hasData: {
        notEmpty: 'ivtDistribution/byMonth'
      }
    },
    permissions: {
      oneOf: ['follower', 'enterprise']
    }
  },
  {
    key: 'app-ad-spend',
    iconURL: '/assets/images/icon-24-incentivized-2.svg',
    label: 'Est. Ad Spend',
    beta: true,
    alwaysShow: true,
    widgetComponent: AppAdSpendSectionComponent,
    showIf: {
      hasData: {
        notEmpty: 'adSpend/byMonth'
      },
      hasPermission: 'mrtAppAdSpend'
    },
    permissions: {
      mustHave: ['enterprise']
    }
  },
  {
    key: 'app-inventory',
    iconURL: '/assets/images/sidenav-icon-inventory.svg',
    label: 'Inventory',
    showInFreemium: true,
    widgetComponent: AppInventorySectionComponent,
    showIf: {
      hasData: {
        notEmpty: [
          'regionDistribution',
          'adSizeDistribution',
          'dmaDistribution'
        ]
      }
    }
  }
];
